import React from 'react';

/* eslint-disable */

export default [
	/* Rune Slot */
	<linearGradient id="slotInner" x1="0" y1="0" x2="0" y2="1">
		<stop offset="0%" stopColor="#0d0f15" />
		<stop offset="100%" stopColor="#11141a" />
	</linearGradient>,
	<linearGradient id="quintHighlight" x1="0" y1="0" x2="0" y2="1">
		<stop offset="0%" stopColor="#1f222a" />
		<stop offset="50%" stopColor="#272132" />
		<stop offset="100%" stopColor="#502242" />
	</linearGradient>,
	<linearGradient id="quintHighlightInner" x1="0" y1="0" x2="0" y2="1">
		<stop offset="0%" stopColor="#0c1117" />
		<stop offset="50%" stopColor="#12121e" />
		<stop offset="100%" stopColor="#25162a" />
	</linearGradient>,
	<linearGradient id="quintHover" x1="0" y1="0" x2="0" y2="1">
		<stop offset="50%" stopColor="#0E1116" />
		<stop offset="100%" stopColor="#ab4e84" />
	</linearGradient>,
	/* Quintessence */
	<linearGradient id="quintOuterStroke" x1="0" y1="0" x2="0" y2="1">
		<stop offset="0%" stopColor="#4839b7" />
		<stop offset="50%" stopColor="#873981" />
		<stop offset="95%" stopColor="#ba5d84" />
	</linearGradient>,
	<linearGradient id="quintOuter" x1="0" y1="0" x2="0" y2="1">
		<stop offset="0%" stopColor="#484480" />
		<stop offset="100%" stopColor="#946d87" />
	</linearGradient>,
	<linearGradient id="quintMiddle" x1="0" y1="0" x2="0" y2="1">
		<stop offset="0%" stopColor="#33385c" />
		<stop offset="100%" stopColor="#584b5f" />
	</linearGradient>,
	/* Quintessence Body */
	<linearGradient
		id="quintBodyStroke"
		gradientUnits="userSpaceOnUse"
		x1="216.2748"
		y1="324.9274"
		x2="216.2748"
		y2="114.6437"
	>
		<stop offset="0" stopColor="#988C69" />
		<stop offset="0.2473" stopColor="#705D31" />
		<stop offset="0.4839" stopColor="#262525" />
		<stop offset="1" stopColor="#0A1721" />
	</linearGradient>,
	<linearGradient
		id="quintBodyInner"
		gradientUnits="userSpaceOnUse"
		x1="216.2748"
		y1="320.4822"
		x2="216.2748"
		y2="119.0889"
	>
		<stop offset="0" stopColor="#00030F" />
		<stop offset="1" stopColor="#2F323F" />
	</linearGradient>,
];
